/**
 *
 * @module component/partials
 * @author Adam Pirani [adam.pirani@mlb.com, mahmud.hossain@mlb.com]
 * @description module for adding handlebars partials
 *
 */

import basesGraphic from '../../template/partials/game/bases-graphic.html';
import broadcasters from '../../template/partials/game/broadcasters.html';
import homeruns from '../../template/partials/panels/secondary/homeruns.html';
import homeRunsTeam from '../../template/partials/panels/secondary/homeruns--team.html';
import interruptedText from '../../template/partials/game/interruptedText.html';
import linescore from '../../template/partials/linescore/linescore.html';
import linescoreBasesGraphic from '../../template/partials/linescore/linescore--bases-graphic.html';
import linescoreButtons from '../../template/partials/linescore/linescore--buttons.html';
import linescoreInnings from '../../template/partials/linescore/linescore--innings.html';
import linescoreProbables from '../../template/partials/linescore/linescore--probables.html';
import linescoreSummary from '../../template/partials/linescore/linescore--summary.html';
import linescoreTeam from '../../template/partials/linescore/linescore--team.html';
import linescoreTeamLeaders from '../../template/partials/linescore/linescore--team-leaders.html';
import linescoreTeamLeadersRow from '../../template/partials/linescore/linescore--team-leaders-row.html';
import linescoreTeamMatchup from '../../template/partials/linescore/linescore--team-matchup.html';
import matchupGraphic from '../../template/partials/panels/video/matchup-graphic.html';
import mig from '../../template/partials/MIG/mig.html';
import migPrimaryPanel from '../../template/partials/MIG/mig--primary-panel.html';
import minisbHoverButtons from '../../template/partials/minisb/minisb-hover-buttons.html';
import player from '../../template/partials/player/player.html';
import players from '../../template/partials/panels/secondary/players.html';
import primaryPanel from '../../template/partials/panels/primary-panel.html';
import secondaryPanel from '../../template/partials/panels/secondary-panel.html';
import videoPanel from '../../template/partials/panels/video-panel.html';
import nonGameEvent from '../../template/partials/game/non-game-event.html';
//Pattern Lib Partials
import logo from '../../template/logo.html';
import icon from '../../template/icon.html';
import buttonGroup from '../../template/button-group.html';
import button from '../../template/button.html';
import embedPlayer from '../../template/embed-player.html';
//postseason sponsored logos
import sponsorship from '../../template/partials/panels/sponsorship.html';
import linescoreCustomButtons from '../../template/partials/linescore/linescore--custom-buttons.html';
//MiLB Partials
import promotion from '../../template/partials/game/promotion.html';
import promotionMilb from '../../template/partials/game/promotion-milb.html';
import milbMigButtons from '../../template/partials/MIG/mig--milb-button-group.html';
import milbMigBaseGraphic from '../../template/partials/game/bases-graphic--milb.html';
import milbMig from '../../template/partials/MIG/mig--milb.html';
import milbLinescoreTeam from '../../template/partials/linescore/linescore--team--milb.html';
import milbMigPrimary from '../../template/partials/MIG/mig--primary-panel--milb.html';
/**
 *
 * @name partials
 * @description handlebars partials to be registered
 * @note paths must be hardcoded because Browserify can only do static string analysis
 *
 */

/* eslint-disable quote-props */
let partials = {
    'bases-graphic': basesGraphic,
    'broadcasters': broadcasters,
    'homeruns': homeruns,
    'homeruns--team': homeRunsTeam,
    'interruptedText': interruptedText,
    'linescore': linescore,
    'linescore--bases-graphic': linescoreBasesGraphic,
    'linescore--buttons': linescoreButtons,
    'linescore--innings': linescoreInnings,
    'linescore--probables': linescoreProbables,
    'linescore--summary': linescoreSummary,
    'linescore--team': linescoreTeam,
    'linescore--team-leaders': linescoreTeamLeaders,
    'linescore--team-leaders-row': linescoreTeamLeadersRow,
    'linescore--team-matchup': linescoreTeamMatchup,
    'matchup-graphic': matchupGraphic,
    'mig': mig,
    'mig--primary-panel': migPrimaryPanel,
    'minisb-hover-buttons': minisbHoverButtons,
    'player': player,
    'players': players,
    'primary-panel': primaryPanel,
    'secondary-panel': secondaryPanel,
    'video-panel': videoPanel,
    //Pattern Lib Partials
    'pattern/logo': logo,
    'pattern/icon': icon,
    'pattern/button-group': buttonGroup,
    'pattern/button': button,
    'pattern/embed-player': embedPlayer,
    'sponsorship': sponsorship,
    'linescore--custom-buttons': linescoreCustomButtons,
    'promotion': promotion,
    'non-game-event': nonGameEvent,

    // milb partials
    'promotion-milb': promotionMilb,
    'milb-buttons': milbMigButtons,
    'bases-graphic--milb': milbMigBaseGraphic,
    'migmilb': milbMig,
    'linescore--team--milb': milbLinescoreTeam,
    'mig--primary-panel--milb': milbMigPrimary
};
/* eslint-enable quote-props */

export default partials;
